import React from 'react';
import PropTypes from 'prop-types';

import I18n from '@module/i18n';
import Icon from '@app/component/icon/index';
import { DODGER_BLUE } from '@constant/colors';

export const LockedSender = ({ sender, onMouseOver, onFocus }) => {
  return (
    <div
      className="uploader__locked-sender"
      onMouseOver={onMouseOver}
      onFocus={onFocus}
    >
      <span className="uploader__locked-sender-label">
        {I18n.t('transfer.form.from')}
      </span>
      <span className="uploader__locked-sender-email" title={sender}>
        {sender}
      </span>
      <Icon
        type="CheckCircle"
        color={DODGER_BLUE}
        className="email-verification__success--checkmark"
      />
    </div>
  );
};

LockedSender.propTypes = {
  sender: PropTypes.string.isRequired,
  onMouseOver: PropTypes.func,
  onFocus: PropTypes.func,
};

export default React.memo(LockedSender);
